import { IReportingPeriodService } from "../../service/reporting/ReportingPeriodService";
import { IReportingPeriod } from "../../model/reporting/ReportingPeriod";

export default class AssignApplicantsToReportingPeriodInteractor {
  private reportingPeriodService: IReportingPeriodService;
  constructor(reportingPeriodService) {
    this.reportingPeriodService = reportingPeriodService;
  }

  async execute(reportingPeriod: IReportingPeriod) {
    return this.reportingPeriodService.assignApplicantsToReportingPeriod(
      reportingPeriod
    );
  }
}
